import { Link as UILink } from '@flippingbook/web.react-kit/dist/Link';
import { forwardRef } from 'react';
import type { To } from 'react-router-dom';

import { useRouterLinkProps } from '@/hooks/useRouterLinkProps';

export const Link = forwardRef<HTMLAnchorElement, Link.Props>(function LinkWithRef(props, ref) {
    const { to, target, replace = false, reloadDocument, state, onClick, ...rest } = props;

    const routerProps = useRouterLinkProps({
        to,
        target,
        replace,
        reloadDocument,
        state,
        onClick,
    });

    return (
        <UILink
            {...rest}
            {...routerProps}
            ref={ref}
            target={target}
        />
    );
});

export namespace Link {
    type LinkProps = React.ComponentPropsWithoutRef<typeof UILink>;

    export interface Props extends Omit<LinkProps, 'href'> {
        to: To;
        reloadDocument?: boolean;
        replace?: boolean;
        // state is typed like `useLinkClickHandler` prop
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        state?: any;
    }
}
